import appStore,{userAtom} from "../store";

// const viewObject: Record<string, Record<string, boolean | undefined>> = {
//     'Administrator':{
//         'Overview':true,
//         'Settings':true,
//         'Candidates':true,
//         'Applications':true,
//         'Approvals':true,
//         'Reports':true,
//         'Induction Report':true,
//         'Transactions':true,
//         'Publish Results':true,
//         'Induction':true,

//     },
//     'Administrator 1':{
//         'Overview':true,
//         'Settings':true,
//         'Candidates':true,
//         'Applications':true,
//         'Approvals':true,
//         'Reports':true,
//         'Transactions':true,
//         'Publish Results':true,
//         'Induction':true,
//     },
//     'Administrator 2':{
//         'Settings':true,
//         'Overview':true,
//         'Candidates':true,
//         'Applications':true,
//         'Approvals':true,
//         'Reports':true,
//         'Transactions':true,
//         'Publish Results':true,
//     },
//     'Exam Admin level 1':{
//         'Settings':true,       
//         'Approvals':true,
//         'Transactions':true,
//         'Publish Results':true,
//         'Induction':true,
//         'Overview':true,
//         'Candidates':true,
//         'Applications':true,
//         'Reports':true,

//     },
//     'Exam Admin level 2':{
//         'Settings':true,
//         'Candidates':false,
//         'Applications':false,
//         'Approvals':false,
//         'Reports':false,
//         'Transactions':false,
//         'Publish Results':false,
//         'Overview':true,
//     },
//     'Team leads Exam':{
//         'Induction':false,
//         'Overview':true,
//         'Settings':true,
//         'Candidates':true,
//         'Applications':true,
//         'Approvals':true,
//         'Reports':true,
//         'Transactions':true,
//         'Publish Results':true,
//     }

// }

// const useView = () => {
//   const userData = appStore.get(userAtom);
//   const roles: Record<string, boolean> = {

//   };
//   if(userData && userData.RoleNames && userData.RoleNames.length > 0)
//   for(const name of userData?.RoleNames){
//     let tempName: string = name;
//     roles[tempName] = true;
//   } 
  
//   return (tab:string)=>{
//     let result = false;
//     for(const name in roles){
//         let tempName = viewObject[name] ? viewObject[name][tab] : false;
//         result = result || Boolean(tempName);
//     }
//     return result;
//   }
// }

const useView = ()=>{
    let tempUserData = localStorage.getItem('user-data');
    let uData = JSON.parse(tempUserData || '{}');

    const userData = uData;

    if(!userData) return (temp_permission: string) => false;

    let permissions = userData.Permissions ;
    let pathname = userData.PathName;
    
    let arr: Record<string, Record<string,string>>  = {};

    let len = permissions?.length || 0;
    for(let i = 0; i < len; i++){
        let eachPermission: string = permissions[i]?.toString()?.toLowerCase() || `null${i}`
        let eachPathname: string = pathname[i]?.toString()?.toLowerCase() || `null${i+""+i}`;
        arr[eachPermission] = {
            permission:eachPermission,
            pathname: eachPathname,
        }
    }
    //console.log(arr,'array')

    return (temp_permission: string) => arr[temp_permission.toLowerCase()]?true:false;
}

export default useView